import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MarkdownRenderer from 'react-markdown-renderer'
import { fileTypes } from '../../constants'
import { createHtmlElement } from '../../utils/index'
import Modal from '../mini/Modal'
import ContentWarnings from '../mini/ContentWarnings'
import styled from 'styled-components'
import { H1, H3, H5, P2, Caption1 } from '../styled/typography/typography'
import { LexiconContext } from '../../contexts/Lexicon'

const MentorNotesH1 = styled(H1)`
  margin: 0 auto;
  text-align: center;
`

const MentorNotesH3 = styled(H3)`
  margin: 25px 0 14px;
  
  &.overview-title {
      margin-top: 32px;
  }
`

export default class MentorNotes extends Component {
  static contextType = LexiconContext
  render () {
    const { quest, closeCallback } = this.props

    return (
      <Modal
        width={740}
        // percentHeight={70}
        allowInnerScroll
        closeCallback={closeCallback}
      >
        <div className='mentor-notes-modal-container'>

          <div className='header'>
            <MentorNotesH1>Just for Mentors</MentorNotesH1>
            <div className='close' onClick={closeCallback}></div>
          </div>

          <div className='body'>

            {quest.document.inline_mentor_notes &&
              <P2 className='markdown'>
                <MarkdownRenderer
                  options={{
                    linkTarget: '_blank'
                  }}
                  markdown={quest.document.inline_mentor_notes} />
              </P2>
            }

            {quest.document.mentor_note_files.length > 0 &&
              <ul className='mentor-file-list'>
                {quest.document.mentor_note_files.map(function (file, index) {
                  return <li key={index}>
                    <a href={file.attachment_url} target='_blank'>
                      <div className='name'>
                        <div className={'file ' + fileTypes[file.file_type]}></div>
                        <H5>{file.attachment_name}</H5>
                      </div>
                      <Caption1
                        className='description'
                        dangerouslySetInnerHTML={createHtmlElement(file.description_html)}>
                      </Caption1>
                    </a>
                  </li>
                }, this)}
              </ul>
            }

            {this.hasContentWarnings() &&
              <div>
                <MentorNotesH3>Content Warnings</MentorNotesH3>
                <P2 className='markdown pad'>
                  One or more resources in the ${this.context.lexicon.quest.toLowerCase()} have the following content warnings:
                </P2>
                <ContentWarnings
                  contentWarnings={quest.unique_content_warnings}
                  displayListWithText
                />
              </div>
            }

            {quest.document.authors_shown_as &&
              <Caption1 className='authors'>&mdash; <span>{quest.document.authors_shown_as}</span></Caption1>
            }
          </div>
        </div>
      </Modal>
    )
  }

  hasContentWarnings () {
    const { quest } = this.props
    return quest.unique_content_warnings && quest.unique_content_warnings.length > 0
  }
}

MentorNotes.propTypes = {
  quest: PropTypes.object,
  closeCallback: PropTypes.func
}
